module.exports = __webpack_public_path__ + "static/media/plus.daadcfa3.svg";